var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import * as _ from "lodash";
var elementResizeDetectorMaker = require("element-resize-detector");
var erdUltraFast = elementResizeDetectorMaker({
    strategy: "scroll" //<- For ultra performance.
});
var standardSizeConditionalConfig = {
    breakpoints: {
        mobile: { width: 400 },
        tablet: { width: 768 },
        desktop: { width: 1024 },
        large: { width: 1280 },
        wide: { width: 1600 },
        ultraWide: { width: 1920 }
    },
    initialCurrentBreakpoint: "verysmall"
};
export default function sizeConditional(config) {
    var c = config ? config : standardSizeConditionalConfig;
    _.forEach(standardSizeConditionalConfig, function (v, k) {
        if (!c[k])
            c[k] = standardSizeConditionalConfig[k];
    });
    var brArray = [];
    _.forEach(c.breakpoints, function (breakpoint, name) {
        brArray.push({ breakpoint: breakpoint, name: name });
    });
    _.sortBy(brArray, function (b) { return b.breakpoint.width; });
    var toRet = function (cmp) {
        return /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1(props) {
                var _this = _super.call(this, props) || this;
                _this.width = 0;
                _this.height = 0;
                _this.debounceState = _.debounce(function (val) {
                    _this.setState(val);
                }, 500);
                _this.first = true;
                _this.handleContextRef = function (contextRef) {
                    if (contextRef)
                        erdUltraFast.listenTo({}, contextRef, function (ele) {
                            _this.onResize(ele.offsetWidth, ele.offsetHeight);
                        });
                };
                _this.onResize = function (width, height) {
                    var currentBreakpoint = _this.calcRenderType(width, height);
                    if (_this.first || currentBreakpoint !== _this.state.currentBreakpoint || ((width !== _this.width || height !== _this.height) && c.updateSize)) {
                        _this.width = width;
                        _this.height = height;
                        _this.first = false;
                        _this.debounceState({ currentBreakpoint: currentBreakpoint, width: width, height: height });
                    }
                };
                _this.calcRenderType = function (width, height) {
                    var bp = c.initialCurrentBreakpoint ? c.initialCurrentBreakpoint : "undefined";
                    _.forEach(brArray, function (br) {
                        if (width >= br.breakpoint.width && (!br.breakpoint.height || height >= br.breakpoint.height))
                            bp = br.name;
                    });
                    return bp;
                };
                _this.state = {
                    width: 0,
                    height: 0,
                    currentBreakpoint: c.initialCurrentBreakpoint ? c.initialCurrentBreakpoint : "undefined" /* will never happen ;) */,
                };
                return _this;
            }
            class_1.prototype.render = function () {
                var C = cmp;
                var props = __assign(__assign({}, this.props), { currentBreakpoint: this.state.currentBreakpoint, width: this.state.width, height: this.state.height, breakpoints: c.breakpoints });
                return (React.createElement("div", { ref: this.handleContextRef, className: c.className, style: c.style },
                    React.createElement(C, __assign({}, props))));
            };
            return class_1;
        }(React.Component));
    };
    return toRet;
}
//# sourceMappingURL=SizeConditional.js.map